import React from "react";
import { chefInfo } from "../mock";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-400 border-t border-neutral-800 py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full border-2 border-[#fbf3e4] flex items-center justify-center">
            <span className="font-display text-sm text-[#fbf3e4] leading-none">M</span>
          </div>
          <div>
            <div className="font-display text-sm text-[#fbf3e4] tracking-wider">METE</div>
            <div className="text-[10px] tracking-[0.3em] text-neutral-500">PRIVATE CHEF</div>
          </div>
        </div>
        <div className="text-xs tracking-[0.2em]">
          © {new Date().getFullYear()} PRIVATE CHEF METE — ALL RIGHTS RESERVED
        </div>
        <div className="flex items-center gap-4">
          <a href={`mailto:${chefInfo.email}`} className="hover:text-[#fbf3e4] transition-colors"><Mail size={18} /></a>
          <a href={chefInfo.instagram} target="_blank" rel="noreferrer" className="hover:text-[#fbf3e4] transition-colors"><Instagram size={18} /></a>
        </div>
      </div>
    </footer>
  );
}
